import { useTranslation } from 'react-i18next';

import { SectionWrapper } from '@/features/homepage/components/shared';

function Philosophy() {
	const { t } = useTranslation();

	return (
		<SectionWrapper heading={t('home.philosophy.heading')}>
			<PhilosophySection
				title={t('home.philosophy.sections.learningBasicMovements.title')}
				description={t('home.philosophy.sections.learningBasicMovements.description')}
			/>
			<PhilosophySection
				title={t('home.philosophy.sections.masteringBasicMovements.title')}
				description={t('home.philosophy.sections.masteringBasicMovements.description')}
			/>
			<PhilosophySection
				title={t('home.philosophy.sections.progressiveOverload.title')}
				description={t('home.philosophy.sections.progressiveOverload.description')}
			/>
		</SectionWrapper>
	);
}

interface PhilosophySectionProps {
	title: string;
	description: string;
}
function PhilosophySection(props: PhilosophySectionProps) {
	return (
		<div className="mb-10 px-4 first:mt-0">
			<div className="my-2 flex items-center">
				<span className="me-3 inline-block size-1.5 rounded-full bg-ash-400" />
				<h3 className="">{props.title}</h3>
			</div>
			<p className="ms-5">{props.description}</p>
		</div>
	);
}

export { Philosophy };
